export default {
  buttons: { done: 'Terminé' },
  title: 'Localisation',
};
